export const API_FETCH_ABORT_SYMBOL = Symbol('API_FETCH_ABORT_SYMBOL');
export const API_GLOBAL_ERROR = Symbol('API_GLOBAL_ERROR');
export const API_LOCAL_ERROR = Symbol('API_LOCAL_ERROR');
export const API_FORBIDDEN_EXCEPTION_ERROR = Symbol('API_FORBIDDEN_EXCEPTION_ERROR');
